import { createContainer, createHook, createStore } from '@atlassian/react-sweet-state';
import { actions } from './actions/index.tsx';
import { INITIAL_STATE } from './constants.tsx';
import type { ContainerProps, State } from './types.tsx';

export const RecurWorkItemContainer = createContainer<ContainerProps>();

const Store = createStore<State, typeof actions, ContainerProps>({
	name: 'RecurWorkItemStore',
	initialState: INITIAL_STATE,
	actions,
	containedBy: RecurWorkItemContainer,
	handlers: {
		onInit:
			() =>
			async ({ dispatch }) => {
				await dispatch(actions.bootstrap());
			},
	},
});

export const useRecurWorkItem = createHook(Store);
